module.exports = __webpack_public_path__ + "img/4-3.de02c2da.svg";